<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      Edit
      @if (!loading && quote) {
        <p class="subtitle">Quote #{{quote.number}}</p>
      }
    </ion-title>
    @if (online && !loading) {
      <ion-buttons slot="end">
        <ion-button (click)="update()">
          <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
        </ion-button>
      </ion-buttons>
    }
  </ion-toolbar>

</ion-header>

<ion-content>

  @if (online && !loading) {
    <ion-grid class="form">
      <ion-row>
        <ion-col>
          <ion-grid class="fieldset">
            @if (['draft','sent','declined'].includes(quote.status)) {
              <ion-row>
                <ion-col>
                  @if (person_name) {
                    <ion-input class="modal-input" readonly="true" labelPlacement="stacked" fill="outline" (click)="presentPersonPickerModal()" value={{person_name}}>
                      <div slot="label">Person<ion-text class="optional">optional</ion-text></div>
                    </ion-input>
                  }
                  @if (!person_name) {
                    <ion-input class="modal-input" readonly="true" labelPlacement="stacked" fill="outline" (click)="presentPersonPickerModal()">
                      <div slot="label">Person<ion-text class="optional">optional</ion-text></div>
                    </ion-input>
                  }
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  @if (organisation) {
                    <ion-input class="modal-input" readonly="true" labelPlacement="stacked" fill="outline" (click)="presentOrganisationPickerModal()" value={{organisation.title}}>
                      <div slot="label">Organisation<ion-text class="optional">optional</ion-text></div>
                    </ion-input>
                  }
                  @if (!organisation) {
                    <ion-input class="modal-input" readonly="true" labelPlacement="stacked" fill="outline" (click)="presentOrganisationPickerModal()">
                      <div slot="label">Organisation<ion-text class="optional">optional</ion-text></div>
                    </ion-input>
                  }
                </ion-col>
              </ion-row>
            }
            <ion-row>
              <ion-col>
                <ion-input type="text" inputmode="text" maxlength="100" labelPlacement="stacked" fill="outline" [(ngModel)]="params['reference']">
                  <div slot="label">Reference<ion-text class="optional">optional</ion-text></div>
                </ion-input>
              </ion-col>
            </ion-row>
          </ion-grid>
          @if (['draft','sent','declined'].includes(quote.status)) {
            <ion-grid class="fieldset">
              @if (pricing_tiers && pricing_tiers.length != 0) {
                <ion-row>
                  <ion-col>
                    <ion-select okText="OK" interface="alert" label="Pricing tier" labelPlacement="stacked" fill="outline" [(ngModel)]="params['pricing_tier_id']">
                      @for (pricing_tier of pricing_tiers; track pricing_tier) {
                        @if (pricing_tier.sellable == true) {
                          <ion-select-option value="{{pricing_tier.id}}">{{pricing_tier.title}}</ion-select-option>
                        }
                      }
                    </ion-select>
                  </ion-col>
                </ion-row>
              }
              @if (tax_zones && tax_zones.length != 0) {
                <ion-row>
                  <ion-col>
                    <ion-select okText="OK" interface="alert" label="Tax zone" labelPlacement="stacked" fill="outline" [(ngModel)]="params['tax_zone_id']">
                      @for (tax_zone of tax_zones; track tax_zone) {
                        <ion-select-option value="{{tax_zone.id}}">
                          {{tax_zone.country.title}}
                          @if (tax_zone.country.subdivision) {
                            @if (tax_zone.country.subdivision.title) {
                              <span> / {{tax_zone.country.subdivision.title}}</span>
                            }
                            @if (!tax_zone.country.subdivision.title) {
                              <span> / any</span>
                            }
                          }
                        </ion-select-option>
                      }
                    </ion-select>
                  </ion-col>
                </ion-row>
              }
            </ion-grid>
          }
          @if (['draft','sent','declined'].includes(quote.status) || quote.sent_date || quote.declined_date || quote.accepted_date || quote.cancelled_date) {
            <ion-grid class="fieldset">
              @if (['draft','sent','declined'].includes(quote.status)) {
                <ion-row>
                  <ion-col>
                    @if (params['expiry_date']) {
                      <ion-input class="modal-input" readonly="true" labelPlacement="stacked" fill="outline" value={{formatted_expiry_date}} (click)="presentExpiryDateTimePickerModal()">
                        <div slot="label">Expiry date<ion-text class="optional">optional</ion-text></div>
                      </ion-input>
                    }
                    @if (!params['expiry_date']) {
                      <ion-input class="modal-input" readonly="true" labelPlacement="stacked" fill="outline" (click)="presentExpiryDateTimePickerModal()">
                        <div slot="label">Expiry date<ion-text class="optional">optional</ion-text></div>
                      </ion-input>
                    }
                  </ion-col>
                </ion-row>
              }
              @if (quote.sent_date) {
                <ion-row>
                  <ion-col>
                    @if (params['sent_date']) {
                      <ion-input class="modal-input" readonly="true" label="Sent date" labelPlacement="stacked" fill="outline" value={{formatted_sent_date}} (click)="presentSentDateTimePickerModal()"></ion-input>
                    }
                    @if (!params['sent_date']) {
                      <ion-input class="modal-input" readonly="true" label="Sent date" labelPlacement="stacked" fill="outline" (click)="presentSentDateTimePickerModal()"></ion-input>
                    }
                  </ion-col>
                </ion-row>
              }
              @if (quote.declined_date) {
                <ion-row>
                  <ion-col>
                    @if (params['declined_date']) {
                      <ion-input class="modal-input" readonly="true" label="Declined date" labelPlacement="stacked" fill="outline" value={{formatted_declined_date}} (click)="presentDeclinedDateTimePickerModal()"></ion-input>
                    }
                    @if (!params['declined_date']) {
                      <ion-input class="modal-input" readonly="true" label="Declined date" labelPlacement="stacked" fill="outline" (click)="presentDeclinedDateTimePickerModal()"></ion-input>
                    }
                  </ion-col>
                </ion-row>
              }
              @if (quote.accepted_date) {
                <ion-row>
                  <ion-col>
                    @if (params['accepted_date']) {
                      <ion-input class="modal-input" readonly="true" label="Accepted date" labelPlacement="stacked" fill="outline" value={{formatted_accepted_date}} (click)="presentAcceptedDateTimePickerModal()"></ion-input>
                    }
                    @if (!params['accepted_date']) {
                      <ion-input class="modal-input" readonly="true" label="Accepted date" labelPlacement="stacked" fill="outline" (click)="presentAcceptedDateTimePickerModal()"></ion-input>
                    }
                  </ion-col>
                </ion-row>
              }
              @if (quote.cancelled_date) {
                <ion-row>
                  <ion-col>
                    @if (params['cancelled_date']) {
                      <ion-input class="modal-input" readonly="true" label="Cancelled date" labelPlacement="stacked" fill="outline" value={{formatted_cancelled_date}} (click)="presentCancelledDateTimePickerModal()"></ion-input>
                    }
                    @if (!params['cancelled_date']) {
                      <ion-input class="modal-input" readonly="true" label="Cancelled date" labelPlacement="stacked" fill="outline" (click)="presentCancelledDateTimePickerModal()"></ion-input>
                    }
                  </ion-col>
                </ion-row>
              }
            </ion-grid>
          }
          @if (['draft','sent','declined'].includes(quote.status)) {
            <ion-grid class="fieldset">
              <ion-row>
                <ion-col>
                  <h3>Shipping address</h3>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  @if (address_requires_first_name) {
                    <ion-input type="text" inputmode="text" maxlength="50" label="First name" labelPlacement="stacked" fill="outline" [(ngModel)]="params['shipping_address_first_name']"></ion-input>
                  }
                  @if (!address_requires_first_name) {
                    <ion-input type="text" inputmode="text" maxlength="50" labelPlacement="stacked" fill="outline" [(ngModel)]="params['shipping_address_first_name']">
                      <div slot="label">First name<ion-text class="optional">optional</ion-text></div>
                    </ion-input>
                  }
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  @if (address_requires_last_name) {
                    <ion-input type="text" inputmode="text" maxlength="50" label="Last name" labelPlacement="stacked" fill="outline" [(ngModel)]="params['shipping_address_last_name']"></ion-input>
                  }
                  @if (!address_requires_last_name) {
                    <ion-input type="text" inputmode="text" maxlength="50" labelPlacement="stacked" fill="outline" [(ngModel)]="params['shipping_address_last_name']">
                      <div slot="label">Last name<ion-text class="optional">optional</ion-text></div>
                    </ion-input>
                  }
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <ion-input type="text" inputmode="text" maxlength="100" labelPlacement="stacked" fill="outline" [(ngModel)]="params['shipping_address_organisation_title']">
                    <div slot="label">Organisation title<ion-text class="optional">optional</ion-text></div>
                  </ion-input>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  @if (country) {
                    <ion-input class="modal-input" readonly="true" label="Country" labelPlacement="stacked" fill="outline" (click)="presentCountryPickerModal()" value={{country.title}}></ion-input>
                  }
                  @if (!country) {
                    <ion-input class="modal-input" readonly="true" label="Country" labelPlacement="stacked" fill="outline" (click)="presentCountryPickerModal()"></ion-input>
                  }
                </ion-col>
              </ion-row>
              @if (country) {
                <ion-row>
                  <ion-col>
                    <ion-input type="text" inputmode="text" maxlength="100" labelPlacement="stacked" fill="outline" [(ngModel)]="params['shipping_address_premises']">
                      <div slot="label">Unit / Level / Building<ion-text class="optional">optional</ion-text></div>
                    </ion-input>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>
                    @if (address_requires_line_1) {
                      <ion-input type="text" inputmode="text" maxlength="100" label="Line 1" labelPlacement="stacked" fill="outline" [(ngModel)]="params['shipping_address_line_1']"></ion-input>
                    }
                    @if (!address_requires_line_1) {
                      <ion-input type="text" inputmode="text" maxlength="100" labelPlacement="stacked" fill="outline" [(ngModel)]="params['shipping_address_line_1']">
                        <div slot="label">Line 1<ion-text class="optional">optional</ion-text></div>
                      </ion-input>
                    }
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>
                    <ion-input type="text" inputmode="text" maxlength="100" labelPlacement="stacked" fill="outline" [(ngModel)]="params['shipping_address_line_2']">
                      <div slot="label">Line 2<ion-text class="optional">optional</ion-text></div>
                    </ion-input>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>
                    @if (address_requires_locality) {
                      <ion-input type="text" inputmode="text" maxlength="50" label="Town / City" labelPlacement="stacked" fill="outline" [(ngModel)]="params['shipping_address_locality']"></ion-input>
                    }
                    @if (!address_requires_locality) {
                      <ion-input type="text" inputmode="text" maxlength="50" labelPlacement="stacked" fill="outline" [(ngModel)]="params['shipping_address_locality']">
                        <div slot="label">Town / City<ion-text class="optional">optional</ion-text></div>
                      </ion-input>
                    }
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>
                    @if (address_requires_subdivision && address_subdivision_label_changed) {
                      <ion-select cancelText="Close" interface="alert" label="{{address_subdivision_label}}" labelPlacement="stacked" fill="outline" [(ngModel)]="params['shipping_address_subdivision']">
                        @for (subdivision of subdivisions; track subdivision) {
                          <ion-select-option value="{{subdivision.title}}">{{subdivision.title}}</ion-select-option>
                        }
                      </ion-select>
                    }
                    @if (!address_requires_subdivision &&address_subdivision_label_changed) {
                      <ion-input type="text" inputmode="text" maxlength="50" labelPlacement="stacked" fill="outline" [(ngModel)]="params['shipping_address_subdivision']">
                        <div slot="label">{{address_subdivision_label}}<ion-text class="optional">optional</ion-text></div>
                      </ion-input>
                    }
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>
                    @if (address_requires_postal_code) {
                      <ion-input type="text" inputmode="text" maxlength="10" label="{{address_postal_code_label}}" labelPlacement="stacked" fill="outline" [(ngModel)]="params['shipping_address_postal_code']"></ion-input>
                    }
                    @if (!address_requires_postal_code) {
                      <ion-input type="text" inputmode="text" maxlength="10" labelPlacement="stacked" fill="outline" [(ngModel)]="params['shipping_address_postal_code']">
                        <div slot="label">{{address_postal_code_label}}<ion-text class="optional">optional</ion-text></div>
                      </ion-input>
                    }
                  </ion-col>
                </ion-row>
              }
              <ion-row>
                <ion-col>
                  <ion-input type="text" inputmode="text" maxlength="130" labelPlacement="stacked" fill="outline" [(ngModel)]="params['shipping_address_what3words_address']">
                    <div slot="label">what3words address<ion-text class="optional">optional</ion-text></div>
                  </ion-input>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <ion-input type="text" inputmode="text" maxlength="100" [counter]="true" labelPlacement="stacked" fill="outline" [(ngModel)]="params['shipping_address_courier_instructions']">
                    <div slot="label">Courier instructions<ion-text class="optional">optional</ion-text></div>
                  </ion-input>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  @if (address_requires_mobile_phone_number) {
                    <ion-input type="tel" inputmode="tel" maxlength="20" label="Mobile phone number" labelPlacement="stacked" fill="outline" [(ngModel)]="params['shipping_address_mobile_phone_number']"></ion-input>
                  }
                  @if (!address_requires_mobile_phone_number) {
                    <ion-input type="tel" inputmode="tel" maxlength="20" labelPlacement="stacked" fill="outline" [(ngModel)]="params['shipping_address_mobile_phone_number']">
                      <div slot="label">Mobile phone number<ion-text class="optional">optional</ion-text></div>
                    </ion-input>
                  }
                </ion-col>
              </ion-row>
            </ion-grid>
          }
          @if (['draft','sent','declined'].includes(quote.status)) {
            <ion-grid class="fieldset">
              <ion-row>
                <ion-col>
                  <ion-input type="email" inputmode="email" maxlength="320" labelPlacement="stacked" fill="outline" [(ngModel)]="params['shipping_notification_email_address']">
                    <div slot="label">Shipping notification email address<ion-text class="optional">optional</ion-text></div>
                  </ion-input>
                </ion-col>
              </ion-row>
            </ion-grid>
          }
          @if (['draft','sent','declined'].includes(quote.status)) {
            <ion-grid class="fieldset">
              <ion-row>
                <ion-col>
                  <ion-textarea type="text" inputmode="text" maxlength="1000" [autoGrow]="true" rows="5" labelPlacement="stacked" fill="outline" [(ngModel)]="params['special_instructions']">
                    <div slot="label">Special instructions<ion-text class="optional">optional</ion-text></div>
                  </ion-textarea>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <ion-textarea type="text" inputmode="text" maxlength="500" [autoGrow]="true" rows="5" labelPlacement="stacked" fill="outline" [(ngModel)]="params['customer_note']">
                    <div slot="label">Note for customer<ion-text class="optional">optional</ion-text></div>
                  </ion-textarea>
                </ion-col>
              </ion-row>
            </ion-grid>
          }
          <ion-grid class="fieldset">
            <ion-row>
              <ion-col>
                <ion-textarea type="text" inputmode="text" maxlength="1000" [autoGrow]="true" rows="5" labelPlacement="stacked" fill="outline" [(ngModel)]="params['internal_note']">
                  <div slot="label">Internal note<ion-text class="optional">optional</ion-text></div>
                </ion-textarea>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-col>
      </ion-row>
    </ion-grid>
  }

</ion-content>